import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import {
  useLoadCandidateAppsQuery,
  useLoadAppRuningTasksQuery,
  useLoadAppDocumentsQuery,
  useLoadAppFormLibraryQuery,
  useLoadAppDocusignDocsQuery,
} from "../../store/candidateApiSlice";
import { getUploadDocDeleteStatus, uploadedDocumentDeleted, deleteUploadedDocument, loadAppDocuments, loadAppDocusignDocs, loadAppFormLibrary, loadAppRuningTasks } from "../../store/candidate";
import {
  getCurrentClientDeatils,
  getCurrentUser,
  getLoggedUserDetails,
  loadClientDetails,
  loadUserDetails,
  sign,
} from "../../store/auth";
import { useNavigate } from "react-router-dom";
import { getFieldData } from "../../../Services/appService";
import UploadDocPopup from "../../../Components/UploadDocPopup";
import { getAlert, getConfirmAlert } from "../../../Services/appAlerts";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import ViewForm from "../../../Components/ApplicantProcessing/ViewForm";
import {
  getReqDocuments,
  getSignedDocumentData,
  loadReqDocuments,
  loadSignedDocument,
  signedDocumentReceived,
} from "../../store/documents";
import useDocDownload from "../../hooks/useDocDownload";
import {
  getComponentUserStatus,
  UpdateComponentsUserStatus,
} from "../../store/tools";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getDocDeletedStatus, partnerCandidateDocDelete } from "../../store/partner";

const CONTRACT_DOC_STYLES = {
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  headerActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.25,
    margin: 0,
  },
  titleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#1d4ed8",
    fontSize: "15px",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0,
  },
  titleText: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#64748b",
    margin: 0,
  },
  heroButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  cardBody: {
    padding: "18px 22px 22px 22px",
  },
  utilityRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px",
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px",
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)",
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px",
  },
  statValue: {
    fontSize: "26px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1,
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: 0,
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)",
  },
  table: {
    marginBottom: 0,
    tableLayout: "fixed",
  },
  serialColumn: {
    width: "4%",
  },
  dateColumn: {
    width: "15%",
  },
  requirementColumn: {
    width: "34%",
  },
  notesColumn: {
    width: "16%",
  },
  statusColumn: {
    width: "12%",
  },
  actionColumn: {
    width: "19%",
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "linear-gradient(180deg, #f8fafc 0%, #f3f6fb 100%)",
    padding: "15px 16px",
    whiteSpace: "nowrap",
  },
  cell: {
    verticalAlign: "middle",
    padding: "20px 16px",
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff",
  },
  serialCell: {
    paddingLeft: "12px",
    paddingRight: "8px",
    textAlign: "center",
  },
  actionCell: {
    paddingRight: "24px",
  },
  serialBadge: {
    minWidth: "30px",
    height: "30px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "12px",
    fontWeight: 800,
  },
  datePrimary: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "4px",
  },
  dateSecondary: {
    fontSize: "12px",
    color: "#64748b",
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent",
  },
  textButton: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "left",
  },
  ellipsisLink: {
    border: "none",
    background: "transparent",
    color: "#4361d9",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "left",
    display: "inline-block",
    maxWidth: "260px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  iconButton: {
    width: "32px",
    height: "32px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.05)",
  },
  infoIconButton: {
    color: "#56607a",
  },
  deleteIconButton: {
    color: "#dc2626",
  },
  requirementPrimary: {
    display: "block",
    maxWidth: "560px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "15px",
    fontWeight: 800,
    letterSpacing: 0,
  },
  requirementSecondary: {
    display: "block",
    fontSize: "13px",
    color: "#0f172a",
    marginTop: "4px",
    maxWidth: "560px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  signPrimaryButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "8px 14px",
    fontSize: "13px",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  signedDocButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#475569",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    minHeight: "36px",
    maxWidth: "100%",
    textDecoration: "none",
  },
  statusStack: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "5px",
  },
  statusDate: {
    color: "#94a3b8",
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: 1.1,
    whiteSpace: "nowrap",
  },
  esignTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    width: "fit-content",
    padding: "2px 8px",
    borderRadius: "99px",
    background: "rgba(37, 99, 235, 0.08)",
    border: "1px solid rgba(37, 99, 235, 0.15)",
    color: "#1d4ed8",
    fontSize: "11px",
    fontWeight: 700,
    marginTop: "5px",
  },
  dangerButton: {
    border: "none",
    background: "transparent",
    color: "#dc2626",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
  },
  actionGroup: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: 0,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  cardList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  docCard: {
    display: "grid",
    gridTemplateColumns: "38px minmax(0, 1fr) auto",
    alignItems: "center",
    gap: "14px",
    padding: "16px",
    background: "#ffffff",
    border: "1px solid #dbe3ef",
    borderRadius: "10px",
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.03)",
  },
  docIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "8px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#2563eb",
    border: "1px solid #dbeafe",
    fontSize: "16px",
  },
  docContent: {
    minWidth: 0,
  },
  docTitleLine: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
  },
  docName: {
    color: "#0f172a",
    fontSize: "15px",
    fontWeight: 800,
    lineHeight: 1.25,
    maxWidth: "640px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  docSubName: {
    color: "#334155",
    fontSize: "14px",
    fontWeight: 800,
    maxWidth: "560px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  docInlineDetail: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    color: "#334155",
    fontSize: "14px",
    fontWeight: 800,
    minWidth: 0,
    maxWidth: "360px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  docMeta: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "7px",
    color: "#64748b",
    fontSize: "12px",
    fontWeight: 600,
  },
  docMetaItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    minWidth: 0,
    maxWidth: "360px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  docActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    minWidth: "420px",
  },
  docDivider: {
    width: "1px",
    height: "24px",
    background: "#cbd5e1",
    margin: "0 2px",
  },
  docEmptyState: {
    padding: "34px 20px",
    textAlign: "center",
    color: "#64748b",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "10px",
  },
};

export default function ContractDocs() {
  const usrType = localStorage.getItem("userType");

  function getContractEsignValue(doc, key) {
    return doc?.[key] ??
      doc?.[`e${key.substring(1)}`] ??
      doc?.[`esign${key.replace(/^ESign/, "")}`];
  }

  function getContractEsignPreparationToken(doc) {
    return getContractEsignValue(doc, "ESignPreparationToken") ||
      doc?.eSignPreparationToken ||
      doc?.esignPreparationToken;
  }

  function getContractEsignEnvelopeId(doc) {
    return doc?.evelopId ||
      doc?.envelopeId ||
      doc?.eSignEnvelopeId ||
      doc?.esignEnvelopeId ||
      getContractEsignPreparationToken(doc);
  }

  function getContractEsignStatus(doc) {
    return getContractEsignValue(doc, "ESignStatus") ||
      doc?.eSignStatus ||
      doc?.esignStatus ||
      doc?.signedStatus ||
      doc?.signedDocStatus;
  }

  function getContractEsignCompletedDate(doc) {
    return getContractEsignValue(doc, "ESignCompletedDateTime") ||
      doc?.eSignCompletedDateTime ||
      doc?.esignCompletedDateTime;
  }

  function normalizeContractEsignStatus(doc) {
    return (getContractEsignStatus(doc) || "").replace(/\s+/g, "").toLowerCase();
  }

  function isContractDocSigned(doc) {
    const status = normalizeContractEsignStatus(doc);
    return status === "1" || status === "signed" || status === "completed" || !!getContractEsignCompletedDate(doc);
  }

  function isContractDocDraft(doc) {
    return normalizeContractEsignStatus(doc) === "draft";
  }

  const [appTasklist, setAppTasklist] = useState([]);
  const [entityType, setEntityType] = useState("");
  const [docLoading, setDocLoading] = useState(false);
  const [docLoadingId, setDocLoadingId] = useState(0);
  const [signLoading, setSignLoading] = useState(false);
  const [uploadDocShowHide, setUploadDocShowHide] = useState(false);
  const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
  const [docType, setDocType] = useState("");
  const [wfTask, setWfTask] = useState(null);
  const [wfId, setWfId] = useState(0);
  const [formShowHide, setFormShowHide] = useState(false);
  const [formObj, setFormObj] = useState(null);
  const [esignLinkLoadingId, setEsignLinkLoadingId] = useState(null);
  const lastComponentUpdateRef = useRef("");

  const currentUser = getCurrentUser();
  let usrId = currentUser?.id;
  if (currentUser?.linkUser) usrId = currentUser.linkUser;

  // Use hooks to auto-fetch candidate data
  const { data: candidateAppsSelector = [] } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });
  const { data: appDocusignDocSelector = [] } = useLoadAppDocusignDocsQuery(usrId, { skip: !usrId });
  const { data: appTasksSelector = [] } = useLoadAppRuningTasksQuery(
    { wfId, userId: usrId },
    { skip: !wfId || !usrId }
  );
  const { data: appFormLibrarySelector = [] } = useLoadAppFormLibraryQuery(
    { wfId, userId: usrId },
    { skip: !wfId || !usrId }
  );
  const { data: appDocumentsSelector = [] } = useLoadAppDocumentsQuery(
    { wfId, userId: usrId },
    { skip: !wfId || !usrId }
  );

  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const reqDocumentsSelector = useSelector(getReqDocuments);
  const signedDocumentDataSelector = useSelector(getSignedDocumentData);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const currentClientDeatilsSelector = useSelector(getCurrentClientDeatils);
  const uploadDocDeleteStatusSelector = useSelector(getUploadDocDeleteStatus);

  const receivedDocs = useMemo(() => {
    return appDocumentsSelector.filter(
      (x) =>
        x.type === "received" &&
        x.uploadType !== "Invoice" &&
        x.uploadType !== "reporting" &&
        x.uploadType !== "client" &&
        x.uploadType !== "project" &&
        x.docType !== "internal" &&
        x.docType !== "Messaging" &&
        x.docModifiedName !== "esign" &&
        x.sendStatus === true &&
        x.deleteFlag !== true
    );
  }, [appDocumentsSelector]);

  const sentDocs = useMemo(() => {
    return appDocumentsSelector.filter(
      (x) =>
        x.type === "send" &&
        x.uploadType !== "Invoice" &&
        x.docType !== "internal" &&
        x.docType !== "Messaging" &&
        x.uploadType !== "Messaging" &&
        x.uploadType !== "reporting" &&
        x.uploadType !== "monthly_time_sheet" &&
        x.uploadType !== "weekly_time_sheet" &&
        x.uploadType?.substring(0, 3) !== "ach" &&
        x.uploadType?.substring(0, 3) !== "req" &&
        x.uploadType?.substring(0, 9) !== "insurance"
    );
  }, [appDocumentsSelector]);

  const reqDocuments = useMemo(() => {
    const usrIdVal = currentUser?.linkUser || currentUser?.id;
    if (!usrIdVal) return [];
    return reqDocumentsSelector.filter(
      (x) =>
        x.sendStatus === true && x.performerId === parseInt(usrIdVal)
    );
  }, [reqDocumentsSelector, currentUser?.id, currentUser?.linkUser]);

  const signDocs = useMemo(() => {
    if (appDocusignDocSelector?.length > 0) {
      return appDocusignDocSelector.filter(
        (x) => x.sendStatus === true && !isContractDocDraft(x)
      );
    }
    return appDocusignDocSelector || [];
  }, [appDocusignDocSelector]);

  const appCiid = useMemo(() => {
    if (appTasklist.length > 0) return appTasklist[0].ciid;
    if (receivedDocs.length > 0) return receivedDocs[0].ciid;
    if (sentDocs.length > 0) return sentDocs[0].ciid;
    if (reqDocuments.length > 0) return reqDocuments[0].ciid;
    return 0;
  }, [appTasklist, receivedDocs, sentDocs, reqDocuments]);

  const [handleDownloadFile, downloadingDocId] = useDocDownload();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const normalizeComponentItems = useCallback((items) => (
    (items || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
      .sort()
      .join(",")
  ), []);

  const handleUpdateComponent = useCallback((compItems, ciid) => {
    const normalizedCompItems = normalizeComponentItems(compItems);
    if (!normalizedCompItems || !(ciid > 0)) return;

    const comp = componentUserStatusSelector.filter((x) => x.compId === 3);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const normalizedUpdCompItems = normalizeComponentItems(updCompItems);
    const updateKey = `${ciid}|${normalizedCompItems}`;

    if (
      normalizedCompItems === normalizedUpdCompItems ||
      lastComponentUpdateRef.current === updateKey
    ) {
      return;
    }

    const compObj = {
      compName: "Contract Document",
      performerId: currentUser.id,
      compItems: normalizedCompItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 3,
    };
    lastComponentUpdateRef.current = updateKey;
    dispatch(UpdateComponentsUserStatus(compObj));
  }, [componentUserStatusSelector, currentUser.id, dispatch, normalizeComponentItems]);

  const getWorkbenchApiBaseUrl = () => (process?.env?.REACT_APP_API_BASEURL || "").replace(/\/$/, "");

  const getEsignApiBaseUrl = () =>
    process?.env?.REACT_APP_ESIGN_API_BASE_URL ||
    process?.env?.REACT_APP_ESIGN_API_BASEURL ||
    process?.env?.REACT_APP_ESIGN_API_URL ||
    (window.location.hostname === "localhost"
      ? "http://localhost:5005"
      : (process?.env?.REACT_APP_ESIGN_BASEURL || ""));



  const getContractEsignUrl = (doc) => {
    const token = getContractEsignPreparationToken(doc);
    if (token) {
      return `${getEsignApiBaseUrl()}/api/public/documents/${token}/sign`;
    }

    const baseUrl = process.env.REACT_APP_ESIGN_BASEURL || "";
    const routeType = doc?.signedStatus === "0" ? "contractPartner" : "esignPartner";
    const docId = doc?.signedStatus === "0" ? doc?.id : doc?.docId;
    return `${baseUrl}/${docId}_${doc.ciid}_${usrId}_${currentClientDeatilsSelector?.clientId}_${doc.documentName}_${routeType}`;
  };

  const getContractSignedDownloadUrl = (doc) => {
    const envelopeId = getContractEsignEnvelopeId(doc);
    if (!envelopeId) return "";

    return `${getEsignApiBaseUrl()}/api/public/documents/${envelopeId}/download/final-signed?inline=true`;
  };

  const getContractEsignBadge = (doc) => {
    const status = getContractEsignStatus(doc);
    const normalized = (status || "").replace(/\s+/g, "").toLowerCase();

    if (isContractDocSigned(doc)) {
      return { text: "Signed", icon: "fa-check-circle", type: "signed" };
    }

    if (normalized === "partiallysigned") {
      return { text: "Partially Signed", icon: "fa-adjust", type: "pending" };
    }

    if (normalized === "draft") {
      return { text: "Draft", icon: "fa-pencil-square-o", type: "sent" };
    }

    if (normalized === "sent" || normalized === "send") {
      return { text: "Received", icon: "fa-inbox", type: "received" };
    }

    if (normalized === "0" || normalized === "pending" || !normalized) {
      return { text: "Pending Signature", icon: "fa-pencil-square-o", type: "pending" };
    }

    if (["expired", "cancelled", "canceled", "rejected"].includes(normalized)) {
      return { text: status, icon: "fa-exclamation-circle", type: "error" };
    }

    return { text: status, icon: "fa-pencil-square-o", type: "pending" };
  };

  const route = [
    { name: "Task Management", url: "" },
    { name: "Onboarding Steps", url: "" },
  ];
  const route1 = [
    { name: "Contract Management", url: "" },
    { name: "Enrollment Steps", url: "" },
  ];

  useEffect(() => {
    dispatch(setCurrentPageTitle("STEP-2 : Contract Documents"));
    dispatch(setCurrentRoute(usrType === "candidate" ? route : route1));
    dispatch(loadClientDetails());
  }, [dispatch, usrType, route, route1]);

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;

    if (!userDetailsSelector && currentUser?.id > 0)
      dispatch(loadUserDetails(usrId));
  }, [dispatch, currentUser?.id, currentUser?.linkUser, userDetailsSelector]);

  useEffect(() => {
    if (candidateAppsSelector.length > 0) {
      const mainWorkflow = candidateAppsSelector.filter(
        (x) => x.workflowType === 1
      );
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0];
        setWfId(wf.oldWorkflowId);
      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(
        (x) => x.taskType === 1 && x.wiid > 0
      );
      setAppTasklist(filterTasks);

      if (filterTasks.length > 0) {
        dispatch(loadReqDocuments(filterTasks[0].ciid));
      }

      if (appTasksSelector.length > 0) {
        const entType = getFieldData(
          appTasksSelector[0].stateData,
          "candidateonboardingform",
          "CandidateEntity"
        );
        setEntityType(entType);
      }
    }
  }, [appTasksSelector, dispatch]);

  useEffect(() => {
    const ids = [];
    receivedDocs.forEach((x) => ids.push(x.id));
    sentDocs.forEach((x) => ids.push(x.id));
    appDocumentsSelector
      .filter((x) => x.docModifiedName === "esign")
      .forEach((x) => ids.push(x.id));
    reqDocuments.forEach((x) => ids.push(x.id));

    const docItems = ids.join(",");
    const targetCiid =
      receivedDocs[0]?.ciid ||
      sentDocs[0]?.ciid ||
      reqDocuments[0]?.ciid ||
      0;

    if (docItems && targetCiid > 0) {
      handleUpdateComponent(docItems, targetCiid);
    }
  }, [receivedDocs, sentDocs, reqDocuments, appDocumentsSelector, handleUpdateComponent]);

  const handleViewSignedDoc = (item, type) => {
    setSelectedSignedDoc(item);
    setSignLoading(true);
    dispatch(loadSignedDocument(item.id, type));
  };

  const handleOpenContractSignLink = async (item) => {
    const docId = item.docId || item.id;

    try {
      setEsignLinkLoadingId(docId);

      const apiBase = getWorkbenchApiBaseUrl();
      if (apiBase) {
        const userEmail = userDetailsSelector?.performeremail || 
                          userDetailsSelector?.performerEmail || 
                          userDetailsSelector?.email || 
                          currentUser?.email || 
                          currentUser?.username || 
                          currentUser?.unique_name || 
                          "";

        const response = await fetch(`${apiBase}/api/ReviewForm/GetDocumentESignSignLink?docId=${docId}&email=${encodeURIComponent(userEmail)}`);
        const data = await response.json().catch(() => null);

        if (response.ok && data?.signingLink) {
          window.open(data.signingLink, "_blank");
          return;
        }
      }

      window.open(getContractEsignUrl(item), "_blank");
    } catch (error) {
      const fallbackUrl = getContractEsignUrl(item);
      if (fallbackUrl) {
        window.open(fallbackUrl, "_blank");
      } else {
        getAlert("", "Unable to connect to eSign. Please try again.", "error");
      }
    } finally {
      setEsignLinkLoadingId(null);
    }
  };

  useEffect(() => {
    if (signedDocumentDataSelector && selectedSignedDoc) {
      window.open(signedDocumentDataSelector.uploadUrl, "_blank");
      setSelectedSignedDoc(null);
      setSignLoading(false);
      dispatch(signedDocumentReceived(null));
    }
  }, [signedDocumentDataSelector, selectedSignedDoc, dispatch]);



  const handleUploadShowHide = (type) => {
    if (type === "save") {
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      setUploadDocShowHide(false);
      dispatch(loadAppDocuments(wfId, usrId));
    } else {
      const reviewApp = appTasklist.filter((x) => x.registrationType === "WP");
      if (reviewApp.length > 0) {
        const lastReviewer = reviewApp[0];
        setWfTask([lastReviewer]);
      } else {
        getAlert("", "No reviewer found", "error");
      }
      setUploadDocShowHide(!uploadDocShowHide);
      setDocType(type);
    }
  };

  const handleFormShowHide = (frm) => {
    if (frm === "save") {
      setFormShowHide(false);
      setFormObj("");
    } else {
      setFormShowHide(!formShowHide);
      setFormObj(frm);
    }
  };

  const handleDeleteFile = async (doc, type, item) => {
    if (item?.status === 1) return getAlert("", "You cannot delete approved document", "error");
    if (item?.docStatus === 1) return getAlert("", "You cannot delete approved document", "error");
    const confirm = await getConfirmAlert("", "Are you sure you want to delete this document?", "warning");
    if (confirm.isConfirmed) {
      dispatch(deleteUploadedDocument(doc.id, type));
    }
  };

  useEffect(() => {
    if (uploadDocDeleteStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      dispatch(uploadedDocumentDeleted(false));
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      if (wfId > 0)
        dispatch(loadAppDocuments(wfId, usrId));
    }
  }, [uploadDocDeleteStatusSelector, wfId, currentUser?.id, currentUser?.linkUser, dispatch])

  const getReqUploadedDocs = (item, type) => {
    const achDocs = appDocumentsSelector.filter(
      (x) => x.docType === `req_${item.id}`
    );
    if (achDocs.length === 0) {
      return (
        <>
          <td style={CONTRACT_DOC_STYLES.cell}>
            <span style={getStatusPillStyles(
              item.docType?.includes("_c2c_")
                ? "contract"
                : item.docType !== "sharing" && !item.docType?.includes("_c2c_") && type !== "received"
                  ? "pending"
                  : "received"
            )}>
              {item.docType?.includes("_c2c_") && "Contract"}
              {item.docType !== "sharing" &&
                !item.docType?.includes("_c2c_") &&
                type !== "received"
                ? "Pending"
                : type === "received" && "Received"}
            </span>
          </td>
          <td style={{ ...CONTRACT_DOC_STYLES.cell, ...CONTRACT_DOC_STYLES.actionCell }}>
            {item.docType !== "sharing" &&
              !item.docType?.includes("_c2c_") &&
              type !== "received" && (
                <button
                  className="btn btn-sm"
                  style={CONTRACT_DOC_STYLES.primaryButton}
                  onClick={() => handleUploadShowHide(`req_${item.id}`)}
                >
                  <i className="fa fa-upload"></i> Upload
                </button>
              )}
          </td>
        </>
      );
    }

    if (achDocs.length > 0) {
      const doc = achDocs[achDocs.length - 1];
      return (
        <>
          <td style={CONTRACT_DOC_STYLES.cell}>
            <span style={getStatusPillStyles("uploaded")}>Uploaded</span>
          </td>
          <td style={{ ...CONTRACT_DOC_STYLES.cell, ...CONTRACT_DOC_STYLES.actionCell }}>
            <div style={CONTRACT_DOC_STYLES.actionGroup}>
              <button
                className="btn btn-sm p-0"
                style={CONTRACT_DOC_STYLES.ellipsisLink}
                title={doc.documentName}
                aria-label={doc.documentName}
                onClick={() => handleDownloadFile(doc)}
              >
                {getDisplayName(doc.documentName)}
              </button>
              {getPopover(doc.notes)}
              <button
                className="btn btn-sm p-0"
                style={{
                  ...CONTRACT_DOC_STYLES.iconButton,
                  ...CONTRACT_DOC_STYLES.deleteIconButton,
                }}
                title="Delete File"
                onClick={() => handleDeleteFile(doc, "doc", item)}
              >
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </td>
        </>
      );
    }
  };

  const getReqRefDocs = (item) => {
    if (item.refDocId > 0) {
      const findDocs = appDocumentsSelector.filter(
        (x) => x.uploadId === item.refDocId
      );
      if (findDocs.length > 0) {
        return (
          <>
            {findDocs.map((doc) => (
              <td key={doc.id} style={CONTRACT_DOC_STYLES.cell}>
                <button
                  className="btn btn-sm p-0"
                  style={{
                    ...CONTRACT_DOC_STYLES.textButton,
                    ...CONTRACT_DOC_STYLES.requirementPrimary,
                  }}
                  title={doc.documentName}
                  aria-label={doc.documentName}
                  onClick={() => handleDownloadFile(doc)}
                >
                  {getDisplayName(doc.documentName)}
                </button>
                <span
                  style={CONTRACT_DOC_STYLES.requirementSecondary}
                  title={item.documnetName}
                >
                  {item.documnetName}
                </span>
              </td>
            ))}
          </>
        );
      }
    }

    return (
      <td style={CONTRACT_DOC_STYLES.cell}>
        <span
          style={CONTRACT_DOC_STYLES.requirementSecondary}
          title={item.documnetName}
        >
          {item.documnetName}
        </span>
      </td>
    );
  };

  const getUnsignedDoc = (item) => {
    const signDoc = appDocumentsSelector.filter(
      (x) => x.docData === item.docData
    );
    if (signDoc.length === 0) {
      return (
        <>
          <td>{item.documentName}</td>
        </>
      );
    }

    if (signDoc.length > 0) {
      const doc = signDoc[0];
      return (
        <>
          <td>
            <button
              className="btn btn-sm p-0"
              style={CONTRACT_DOC_STYLES.textButton}
              title="Download Document"
              onClick={() => handleDownloadFile(doc)}
            >
              {doc.documentName}
            </button>
          </td>
        </>
      );
    }
  };



  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <i
          className="fa fa-info-circle"
          style={{
            ...CONTRACT_DOC_STYLES.iconButton,
            ...CONTRACT_DOC_STYLES.infoIconButton,
            cursor: "pointer",
          }}
        ></i>
      </OverlayTrigger>
    );
  };

  const getPopover1 = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm" style={CONTRACT_DOC_STYLES.subtleButton}>View</button>
      </OverlayTrigger>
    );
  };

  const getNotesButton = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm" style={CONTRACT_DOC_STYLES.signedDocButton}>
          <i className="fa fa-sticky-note-o" aria-hidden="true"></i> Notes
        </button>
      </OverlayTrigger>
    );
  };

  const getDisplayName = (name) => {
    if (!name) return "";
    return name.length > 50 ? `${name.slice(0, 50)}...` : name;
  };

  const getStatusPillStyles = (type) => {
    if (type === "uploaded" || type === "signed" || type === "received") {
      return {
        ...CONTRACT_DOC_STYLES.statusPillBase,
        color: "#166534",
        backgroundColor: "#f0fdf4",
        borderColor: "rgba(187, 247, 208, 1)",
      };
    }

    if (type === "pending") {
      return {
        ...CONTRACT_DOC_STYLES.statusPillBase,
        color: "#92400e",
        backgroundColor: "#fffbeb",
        borderColor: "rgba(253, 230, 138, 1)",
      };
    }

    if (type === "error") {
      return {
        ...CONTRACT_DOC_STYLES.statusPillBase,
        color: "#b91c1c",
        backgroundColor: "#fef2f2",
        borderColor: "#fecaca",
      };
    }

    if (type === "sent" || type === "contract") {
      return {
        ...CONTRACT_DOC_STYLES.statusPillBase,
        color: "#1d4ed8",
        backgroundColor: "#eff6ff",
        borderColor: "rgba(191, 219, 254, 1)",
      };
    }

    return {
      ...CONTRACT_DOC_STYLES.statusPillBase,
      color: "#475569",
      backgroundColor: "#f8fafc",
      borderColor: "rgba(226, 232, 240, 1)",
    };
  };

  const handleDocumentLoad = () => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    const reqCiid = appCiid || appTasklist[0]?.ciid || receivedDocs[0]?.ciid || sentDocs[0]?.ciid || signDocs[0]?.ciid || 0;
    dispatch(loadAppDocuments(wfId, usrId, { subscribe: false, forceRefetch: true }));
    dispatch(loadAppDocusignDocs(usrId, { subscribe: false, forceRefetch: true }));
    dispatch(loadAppFormLibrary(wfId, usrId, { subscribe: false, forceRefetch: true }));
    if (reqCiid > 0) dispatch(loadReqDocuments(reqCiid));
  };

  // Step 1: Merge and tag arrays
  const mergedDocs = [
    ...reqDocuments?.map((item) => ({
      ...item,
      type: "req",
      date: item.addedDateTime,
    })),
    ...receivedDocs?.map((item) => ({
      ...item,
      type: "received",
      date: item.createdDateTime,
    })),
    ...signDocs?.map((item) => ({
      ...item,
      type: "sign",
      date: item.createdDateTime,
    })),
    ...sentDocs?.map((item) => ({
      ...item,
      type: "sent",
      date: item.createdDateTime,
    })),
  ];

  // Step 2: Sort by date (latest first, or reverse if needed)
  const sortedDocs = mergedDocs.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const totalDocuments =
    reqDocuments.length + receivedDocs.length + signDocs.length + sentDocs.length;


  const isSubcontractorReqDoc = (item) =>
    usrType === "subcontractor" ||
    entityType === "C2C Basis" ||
    item?.docType?.includes("_c2c_");

  const isActiveDocument = (doc) => doc && doc.deleteFlag !== true;

  const getReqReferenceDoc = (item) => {
    if (!(item.refDocId > 0)) return null;
    return appDocumentsSelector.find((x) => isActiveDocument(x) && x.uploadId === item.refDocId) || null;
  };

  const getReqUploadedDoc = (item) =>
    appDocumentsSelector.find(
      (x) =>
        isActiveDocument(x) &&
        (
          x.docType === `req_${item.id}` ||
          x.refId === item.id ||
          (
            isSubcontractorReqDoc(item) &&
            item.docType &&
            (x.docType === item.docType || x.uploadType === item.docType)
          )
        )
    ) || null;

  const getDocumentNotes = (item) => {
    const directNotes = item.notes || item.remarks;
    if (directNotes) return directNotes;

    const matchingDoc = appDocumentsSelector.find(
      (doc) =>
        (item.docData && doc.docData === item.docData) ||
        (item.docId && doc.id === item.docId) ||
        (item.id && doc.refId === item.id)
    );

    return matchingDoc?.notes || matchingDoc?.remarks || "";
  };

  const getReqCardStatus = (item, type, uploadedDoc, sentDoc) => {
    if (uploadedDoc) return { label: "Uploaded", type: "uploaded" };
    if (sentDoc && isSubcontractorReqDoc(item)) return { label: "Pending", type: "pending" };
    if (item.docType?.includes("_c2c_")) return { label: "Contract", type: "contract" };
    if (type === "received" || item.docType === "sharing") return { label: "Received", type: "received" };
    return { label: "Pending", type: "pending" };
  };

  const renderSignedActions = (item) => {
    if (getContractSignedDownloadUrl(item)) {
      return (
        <div style={CONTRACT_DOC_STYLES.actionGroup}>
          <a
            className="btn btn-sm"
            style={CONTRACT_DOC_STYLES.signedDocButton}
            title={`View ${item.documentName}`}
            aria-label={`View ${item.documentName}`}
            href={getContractSignedDownloadUrl(item)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-download" aria-hidden="true"></i> View
          </a>
        </div>
      );
    }

    return (
      <div style={CONTRACT_DOC_STYLES.actionGroup}>
        <button
          className="btn btn-sm"
          style={CONTRACT_DOC_STYLES.signedDocButton}
          title={`View ${item.documentName}`}
          aria-label={`View ${item.documentName}`}
          onClick={() => handleViewSignedDoc(item, "1")}
        >
          <i className="fa fa-download" aria-hidden="true"></i> View
        </button>
      </div>
    );
  };

  const renderDocumentCard = (item, key) => {
    const isReq = item.type === "req";
    const isReceived = item.type === "received";
    const isSign = item.type === "sign";
    const isSent = item.type === "sent";
    const refDoc = isReq ? getReqReferenceDoc(item) : null;
    const uploadedReqDoc = (isReq || isReceived) ? getReqUploadedDoc(item) : null;
    const reqDocFile = uploadedReqDoc || refDoc;
    const title = isReq
      ? (reqDocFile?.documentName || item.documnetName || "Required Document")
      : (item.documentName || item.documnetName || "Contract Document");
    const detailTitle = isReq && reqDocFile ? item.documnetName : "";
    const subtitle = !isReq && item.documnetName ? item.documnetName : "";
    const notes = getDocumentNotes(item);

    let status = { label: "Received", type: "received", icon: "fa-inbox" };
    let actions = null;

    if (isReq || isReceived) {
      const reqActionDoc = uploadedReqDoc || (isReq ? refDoc : null);
      status = getReqCardStatus(item, item.type, uploadedReqDoc, refDoc);
      if (reqActionDoc) {
        actions = (
          <div style={CONTRACT_DOC_STYLES.actionGroup}>
            <button
              className="btn btn-sm"
              style={CONTRACT_DOC_STYLES.signedDocButton}
              title={`View ${reqActionDoc.documentName}`}
              aria-label={`View ${reqActionDoc.documentName}`}
              disabled={downloadingDocId === (reqActionDoc.docId || reqActionDoc.id)}
              onClick={() => handleDownloadFile(reqActionDoc)}
            >
              {downloadingDocId === (reqActionDoc.docId || reqActionDoc.id) ? (
                <><i className="fa fa-refresh fa-spin mr-1" aria-hidden="true"></i> Processing...</>
              ) : (
                <><i className="fa fa-download" aria-hidden="true"></i> View</>
              )}
            </button>
            {uploadedReqDoc && refDoc && (
              <button
                className="btn btn-sm"
                style={CONTRACT_DOC_STYLES.signedDocButton}
                title={`View Reference: ${refDoc.documentName}`}
                aria-label={`View Reference: ${refDoc.documentName}`}
                disabled={downloadingDocId === (refDoc.docId || refDoc.id)}
                onClick={() => handleDownloadFile(refDoc)}
              >
                {downloadingDocId === (refDoc.docId || refDoc.id) ? (
                  <><i className="fa fa-refresh fa-spin mr-1" aria-hidden="true"></i> Processing...</>
                ) : (
                  <><i className="fa fa-download" aria-hidden="true"></i> View Ref</>
                )}
              </button>
            )}
            {uploadedReqDoc && (
              <button
                className="btn btn-sm p-0"
                style={{ ...CONTRACT_DOC_STYLES.iconButton, ...CONTRACT_DOC_STYLES.deleteIconButton }}
                title="Delete File"
                onClick={() => handleDeleteFile(uploadedReqDoc, "doc", item)}
              >
                <i className="fa fa-trash"></i>
              </button>
            )}
            {!uploadedReqDoc && isReq && item.docType !== "sharing" && !item.docType?.includes("_c2c_") && (
              <button
                className="btn btn-sm"
                style={CONTRACT_DOC_STYLES.signedDocButton}
                onClick={() => handleUploadShowHide(`req_${item.id}`)}
              >
                <i className="fa fa-upload" aria-hidden="true"></i> Upload
              </button>
            )}
          </div>
        );
      } else if (isReq && item.docType !== "sharing" && !item.docType?.includes("_c2c_")) {
        actions = (
          <button
            className="btn btn-sm"
            style={CONTRACT_DOC_STYLES.signedDocButton}
            onClick={() => handleUploadShowHide(`req_${item.id}`)}
          >
            <i className="fa fa-upload" aria-hidden="true"></i> Upload
          </button>
        );
      }
    }

    if (isReceived) {
      status = { label: "Received", type: "received", icon: "fa-inbox" };
      actions = (
        <button
          className="btn btn-sm"
          style={CONTRACT_DOC_STYLES.signedDocButton}
          title={`View ${item.documentName}`}
          aria-label={`View ${item.documentName}`}
          disabled={downloadingDocId === (item.docId || item.id)}
          onClick={() => handleDownloadFile(item)}
        >
          {downloadingDocId === (item.docId || item.id) ? (
            <><i className="fa fa-refresh fa-spin mr-1" aria-hidden="true"></i> Processing...</>
          ) : (
            <><i className="fa fa-download" aria-hidden="true"></i> View</>
          )}
        </button>
      );
    }

    if (isSign) {
      const badge = getContractEsignBadge(item);
      status = { label: badge.text, type: badge.type, icon: badge.icon };
      actions = isContractDocSigned(item) ? (
        renderSignedActions(item)
      ) : (
        <button
          type="button"
          className="btn btn-sm"
          style={CONTRACT_DOC_STYLES.signPrimaryButton}
          onClick={() => handleOpenContractSignLink(item)}
          disabled={esignLinkLoadingId === (item.docId || item.id)}
        >
          {esignLinkLoadingId === (item.docId || item.id) ? (
            <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Opening...</>
          ) : (
            <><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Sign the Document</>
          )}
        </button>
      );
    }

    if (isSent) {
      status = { label: "Received", type: "received", icon: "fa-inbox" };
      actions = (
        <div style={CONTRACT_DOC_STYLES.actionGroup}>
          <button
            className="btn btn-sm"
            style={CONTRACT_DOC_STYLES.signedDocButton}
            title={`View ${item.documentName}`}
            aria-label={`View ${item.documentName}`}
            disabled={downloadingDocId === (item.docId || item.id)}
            onClick={() => handleDownloadFile(item)}
          >
            {downloadingDocId === (item.docId || item.id) ? (
              <><i className="fa fa-refresh fa-spin mr-1" aria-hidden="true"></i> Processing...</>
            ) : (
              <><i className="fa fa-download" aria-hidden="true"></i> View</>
            )}
          </button>
          <button
            className="btn btn-sm"
            style={{ ...CONTRACT_DOC_STYLES.iconButton, ...CONTRACT_DOC_STYLES.deleteIconButton }}
            title="Delete File"
            onClick={() => handleDeleteFile(item, "doc", item)}
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      );
    }

    return (
      <div key={`${item.type}-${item.id || item.docId || key}`} style={CONTRACT_DOC_STYLES.docCard}>
        <div style={CONTRACT_DOC_STYLES.docIcon}>
          <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
        </div>

        <div style={CONTRACT_DOC_STYLES.docContent}>
          <div style={CONTRACT_DOC_STYLES.docTitleLine}>
            {(reqDocFile || isReceived || isSign || isSent) ? (
              <button
                className="btn btn-sm p-0 doc-link-btn"
                style={{
                  ...CONTRACT_DOC_STYLES.textButton,
                  ...CONTRACT_DOC_STYLES.docName,
                  color: "#2563eb",
                  cursor: "pointer",
                }}
                title={title}
                aria-label={title}
                disabled={downloadingDocId === (reqDocFile?.docId || reqDocFile?.id || item.docId || item.id)}
                onClick={() => reqDocFile ? handleDownloadFile(reqDocFile) : isSign ? handleViewSignedDoc(item, "0") : handleDownloadFile(item)}
              >
                {downloadingDocId === (reqDocFile?.docId || reqDocFile?.id || item.docId || item.id) && (
                  <i className="fa fa-refresh fa-spin mr-1" aria-hidden="true"></i>
                )}
                {getDisplayName(title)}
              </button>
            ) : (
              <span style={CONTRACT_DOC_STYLES.docName} title={title}>{getDisplayName(title)}</span>
            )}
            {detailTitle && (
              <span style={CONTRACT_DOC_STYLES.docInlineDetail} title={detailTitle}>
                <span aria-hidden="true">-</span> {detailTitle}
              </span>
            )}
            {isSign && (
              <span style={CONTRACT_DOC_STYLES.esignTag}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i> eSign
              </span>
            )}
          </div>
          {subtitle && (
            <div style={CONTRACT_DOC_STYLES.docSubName} title={subtitle}>
              {subtitle}
            </div>
          )}
          {isReq && refDoc && uploadedReqDoc && (
            <div style={{ ...CONTRACT_DOC_STYLES.docSubName, display: "flex", alignItems: "center", gap: "6px", marginTop: "4px" }}>
              <span style={{ fontWeight: 600, color: "#64748b" }}>Reference Doc:</span>
              <button
                className="btn btn-sm p-0 doc-link-btn"
                style={{
                  ...CONTRACT_DOC_STYLES.textButton,
                  color: "#2563eb",
                  fontWeight: 700,
                }}
                disabled={downloadingDocId === (refDoc.docId || refDoc.id)}
                onClick={() => handleDownloadFile(refDoc)}
              >
                {downloadingDocId === (refDoc.docId || refDoc.id) && (
                  <i className="fa fa-refresh fa-spin mr-1" aria-hidden="true"></i>
                )}
                {refDoc.documentName}
              </button>
            </div>
          )}
          <div style={CONTRACT_DOC_STYLES.docMeta}>
            <span style={CONTRACT_DOC_STYLES.docMetaItem}>
              <i className="fa fa-calendar" aria-hidden="true"></i>
              <Moment format="MMM Do YYYY">{item.date}</Moment>
            </span>
            <span style={CONTRACT_DOC_STYLES.docMetaItem}>
              <i className="fa fa-clock-o" aria-hidden="true"></i>
              <Moment format="h:mm a">{item.date}</Moment>
            </span>
          </div>
        </div>

        <div style={CONTRACT_DOC_STYLES.docActions}>
          <span style={CONTRACT_DOC_STYLES.statusStack}>
            <span style={getStatusPillStyles(status.type)}>
              {status.icon && <i className={`fa ${status.icon}`} aria-hidden="true"></i>} {status.label}
            </span>
            {isSign && getContractEsignCompletedDate(item) && (
              <span style={CONTRACT_DOC_STYLES.statusDate}>
                <Moment format="MMM Do YYYY">{getContractEsignCompletedDate(item)}</Moment> - <Moment format="h:mm a">{getContractEsignCompletedDate(item)}</Moment>
              </span>
            )}
          </span>
          {(notes || actions) && <span style={CONTRACT_DOC_STYLES.docDivider}></span>}
          {notes && getNotesButton(notes)}
          {actions}
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="mt-2 form-group">
        <style>{`
          .contract-docs-table {
            border-collapse: separate;
            border-spacing: 0;
          }

          .contract-docs-table tbody td {
            transition: background-color 160ms ease, box-shadow 160ms ease;
          }

          .contract-docs-table tbody tr:hover td {
            background-color: #f8fbff !important;
          }

          .contract-docs-table tbody tr:hover td:first-child {
            box-shadow: inset 3px 0 0 #4f46e5;
          }

          .contract-docs-table tbody tr:last-child td {
            border-bottom: none;
          }

          @media (max-width: 991.98px) {
            .contract-docs-table {
              min-width: 1120px;
            }
          }

          .doc-link-btn:hover {
            text-decoration: underline !important;
            color: #1d4ed8 !important;
          }
        `}</style>

        <div className="card border-1 shadow-none" style={CONTRACT_DOC_STYLES.card}>
          <div className="card-header border-1" style={CONTRACT_DOC_STYLES.cardHeader}>
            <div className="row">
              <div className="col-md-8">
                <div style={CONTRACT_DOC_STYLES.titleRow}>
                  <span style={CONTRACT_DOC_STYLES.titleIcon}>
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                  </span>
                  <div style={CONTRACT_DOC_STYLES.titleText}>
                    <div style={CONTRACT_DOC_STYLES.title}>Contract Documents</div>
                    <p style={CONTRACT_DOC_STYLES.subtitle}>
                      Download, complete, sign and upload documents.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-right">
                <div style={CONTRACT_DOC_STYLES.headerActions}>
                  <button
                    className="btn btn-sm"
                    style={CONTRACT_DOC_STYLES.refreshButton}
                    onClick={handleDocumentLoad}
                  >
                    <i className="fa fa-refresh" aria-hidden="true"></i>
                    Refresh
                  </button>
                  <button
                    className="btn btn-sm"
                    style={CONTRACT_DOC_STYLES.heroButton}
                    title="Use this feature to upload any documents as may be required."
                    onClick={() => handleUploadShowHide("")}
                  >
                    <i className="fa fa-upload" aria-hidden="true"></i>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body border-1" style={CONTRACT_DOC_STYLES.cardBody}>
            <div style={CONTRACT_DOC_STYLES.utilityRow}>
              <p style={CONTRACT_DOC_STYLES.helperText}>
                Open password protected documents using the first 3 letters of your first name and the first 3 characters of your ID in lowercase. Example: `abc123`.
              </p>
            </div>
            <div style={CONTRACT_DOC_STYLES.statsRow}>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Total Documents</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{totalDocuments}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  All contract-related documents currently available in this step.
                </div>
              </div>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Required</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{reqDocuments.length}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  Required documents requested as part of onboarding.
                </div>
              </div>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Received</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{receivedDocs.length}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  Files shared back into your contract document workflow.
                </div>
              </div>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Sent / Sign</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{sentDocs.length + signDocs.length}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  Documents sent out plus DocuSign items that still need attention.
                </div>
              </div>
            </div>
            {sortedDocs.length === 0 ? (
              <div style={CONTRACT_DOC_STYLES.docEmptyState}>
                <i className="fa fa-folder-open-o" aria-hidden="true" style={{ fontSize: "22px", color: "#2563eb", marginBottom: "10px" }}></i>
                <h4 style={{ margin: "0 0 6px", color: "#0f172a", fontSize: "16px", fontWeight: 800 }}>No contract documents found</h4>
                <p style={{ margin: 0, color: "#64748b", fontSize: "13px" }}>
                  Contract documents will appear here once they are available for your onboarding.
                </p>
              </div>
            ) : (
              <div style={CONTRACT_DOC_STYLES.cardList}>
                {sortedDocs.map((item, key) => renderDocumentCard(item, key))}
              </div>
            )}

            <div className="table-responsive" style={{ ...CONTRACT_DOC_STYLES.tableWrap, display: "none" }}>
              <table className="table align-items-center table-hover mb-0 contract-docs-table" style={CONTRACT_DOC_STYLES.table}>
                <colgroup>
                  <col style={CONTRACT_DOC_STYLES.serialColumn} />
                  <col style={CONTRACT_DOC_STYLES.dateColumn} />
                  <col style={CONTRACT_DOC_STYLES.requirementColumn} />
                  <col style={CONTRACT_DOC_STYLES.notesColumn} />
                  <col style={CONTRACT_DOC_STYLES.statusColumn} />
                  <col style={CONTRACT_DOC_STYLES.actionColumn} />
                </colgroup>
                <thead>
                  <tr>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}></th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Date & Time</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Requirement</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Notes</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Status</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {sortedDocs.map((item, key) => (
                    <tr key={key}>
                      <td style={{ ...CONTRACT_DOC_STYLES.cell, ...CONTRACT_DOC_STYLES.serialCell }}>
                        <span style={CONTRACT_DOC_STYLES.serialBadge}>{key + 1}</span>
                      </td>
                      <td style={CONTRACT_DOC_STYLES.cell}>
                        <div style={CONTRACT_DOC_STYLES.datePrimary}>
                          <Moment format="MMM Do YYYY">
                            {item.date}
                          </Moment>
                        </div>
                        <div style={CONTRACT_DOC_STYLES.dateSecondary}>
                          <Moment format="h:mm a">
                            {item.date}
                          </Moment>
                        </div>
                      </td>

                      {/* Handle by type */}
                      {item.type === "req" && (
                        <>
                          {getReqRefDocs(item)}
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.notes)}</td>
                          {getReqUploadedDocs(item, "req")}
                        </>
                      )}

                      {item.type === "received" && (
                        <>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <button
                              className="btn btn-sm p-0"
                              style={{
                                ...CONTRACT_DOC_STYLES.textButton,
                                ...CONTRACT_DOC_STYLES.requirementPrimary,
                              }}
                              title={item.documentName}
                              aria-label={item.documentName}
                              onClick={() => handleDownloadFile(item)}
                            >
                              {getDisplayName(item.documentName)}
                            </button>
                          </td>
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.notes)}</td>
                          {getReqUploadedDocs(item, "received")}
                        </>
                      )}

                      {item.type === "sign" && (
                        <>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <button
                              className="btn btn-sm p-0"
                              style={{
                                ...CONTRACT_DOC_STYLES.textButton,
                                ...CONTRACT_DOC_STYLES.requirementPrimary,
                              }}
                              title={item.documentName}
                              aria-label={item.documentName}
                              onClick={() => handleViewSignedDoc(item, "0")}
                            >
                              {getDisplayName(item.documentName)}
                            </button>
                            <span style={CONTRACT_DOC_STYLES.esignTag}>
                              <i className="fa fa-pencil-square-o" aria-hidden="true"></i> eSign
                            </span>
                          </td>
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.remarks)}</td>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            {(() => {
                              const badge = getContractEsignBadge(item);
                              const completedDate = getContractEsignCompletedDate(item);
                              return (
                                <span style={CONTRACT_DOC_STYLES.statusStack}>
                                  <span style={getStatusPillStyles(badge.type)}>
                                    <i className={`fa ${badge.icon}`} aria-hidden="true"></i> {badge.text}
                                  </span>
                                  {completedDate && (
                                    <span style={CONTRACT_DOC_STYLES.statusDate}>
                                      <Moment format="MMM Do YYYY">{completedDate}</Moment> - <Moment format="h:mm a">{completedDate}</Moment>
                                    </span>
                                  )}
                                </span>
                              );
                            })()}
                          </td>
                          <td style={{ ...CONTRACT_DOC_STYLES.cell, ...CONTRACT_DOC_STYLES.actionCell }}>
                            {isContractDocSigned(item) ? (
                              getContractSignedDownloadUrl(item) ? (
                                <div style={CONTRACT_DOC_STYLES.actionGroup}>
                                  <a
                                    className="btn btn-sm p-0"
                                    style={CONTRACT_DOC_STYLES.signedDocButton}
                                    title={`View ${item.documentName}`}
                                    aria-label={`View ${item.documentName}`}
                                    href={getContractSignedDownloadUrl(item)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="fa fa-eye" aria-hidden="true"></i> View
                                  </a>
                                  <a
                                    className="btn btn-sm p-0"
                                    style={CONTRACT_DOC_STYLES.signedDocButton}
                                    title={`Download ${item.documentName}`}
                                    aria-label={`Download ${item.documentName}`}
                                    href={getContractSignedDownloadUrl(item)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="fa fa-download" aria-hidden="true"></i> Download
                                  </a>
                                </div>
                              ) : (
                                <div style={CONTRACT_DOC_STYLES.actionGroup}>
                                  <button
                                    className="btn btn-sm p-0"
                                    style={CONTRACT_DOC_STYLES.signedDocButton}
                                    title={`View ${item.documentName}`}
                                    aria-label={`View ${item.documentName}`}
                                    onClick={() => handleViewSignedDoc(item, "1")}
                                  >
                                    <i className="fa fa-eye" aria-hidden="true"></i> View
                                  </button>
                                  <button
                                    className="btn btn-sm p-0"
                                    style={CONTRACT_DOC_STYLES.signedDocButton}
                                    title={`Download ${item.documentName}`}
                                    aria-label={`Download ${item.documentName}`}
                                    onClick={() => handleViewSignedDoc(item, "1")}
                                  >
                                    <i className="fa fa-download" aria-hidden="true"></i> Download
                                  </button>
                                </div>
                              )
                            ) : (
                              <button
                                type="button"
                                className="btn btn-sm"
                                style={CONTRACT_DOC_STYLES.signPrimaryButton}
                                onClick={() => handleOpenContractSignLink(item)}
                                disabled={esignLinkLoadingId === (item.docId || item.id)}
                              >
                                {esignLinkLoadingId === (item.docId || item.id) ? (
                                  <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Opening...</>
                                ) : (
                                  <><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Sign the Document</>
                                )}
                              </button>
                            )}
                          </td>
                        </>
                      )}

                      {item.type === "sent" && (
                        <>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <button
                              className="btn btn-sm p-0"
                              style={{
                                ...CONTRACT_DOC_STYLES.textButton,
                                ...CONTRACT_DOC_STYLES.requirementPrimary,
                              }}
                              title={item.documentName}
                              aria-label={item.documentName}
                              disabled={docLoading && item.id === docLoadingId}
                              onClick={() => handleDownloadFile(item)}
                            >
                              {docLoading && item.id === docLoadingId && (
                                <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
                              )}
                              {getDisplayName(item.documentName)}
                            </button>
                          </td>
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.notes)}</td>
                          <td style={CONTRACT_DOC_STYLES.cell}><span style={getStatusPillStyles("received")}>Received</span></td>
                          <td style={{ ...CONTRACT_DOC_STYLES.cell, ...CONTRACT_DOC_STYLES.actionCell }}>
                            <div style={CONTRACT_DOC_STYLES.actionGroup}>
                              <button
                                className="btn btn-sm"
                                style={{
                                  ...CONTRACT_DOC_STYLES.iconButton,
                                  ...CONTRACT_DOC_STYLES.deleteIconButton,
                                }}
                                title="Delete File"
                                onClick={() => handleDeleteFile(item, "doc", item)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {uploadDocShowHide && (
        <UploadDocPopup
          uploadDocShowHide={uploadDocShowHide}
          handleUploadDocModalShowHide={handleUploadShowHide}
          runningApplication={wfTask}
          selectedDocType={docType}
          contactDoc={
            docType === ""
              ? "Your document has been successfully attached to workbench portal"
              : "Your required document has been successfully attached to workbench portal"
          }
        ></UploadDocPopup>
      )}
      {formShowHide && (
        <ViewForm
          formShowHide={formShowHide}
          handleFormShowHide={handleFormShowHide}
          workflowTask={wfTask}
          selectedForm={formObj}
        ></ViewForm>
      )}
    </React.Fragment>
  );
}
